"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var Check = function (_a) {
    var _b = _a.width, width = _b === void 0 ? '12' : _b, _c = _a.height, height = _c === void 0 ? '10' : _c, _d = _a.fillColor, fillColor = _d === void 0 ? '#006601' : _d, rest = __rest(_a, ["width", "height", "fillColor"]);
    return (react_1["default"].createElement("svg", { width: width, height: height, viewBox: "0 0 13 11" },
        react_1["default"].createElement("path", { d: "M5.20994 8.41387L1.56004 4.81983L0.349609 6.03026L4.61404 10.2947C4.7723 10.5057 5.02067 10.6299 5.28443 10.6299C5.52403 10.6131 5.74623 10.4987 5.89896 10.3133L12.7332 1.69134L11.3924 0.629883L5.20994 8.41387Z", fill: fillColor })));
};
exports["default"] = Check;
